// extracted by mini-css-extract-plugin
export default {"main":"BasicPage_main__T8uSf"};